<template>
  <div class="faq">
    <div>
      <div>
        <h2 class="faq-info__title mt-5">Frequently asked questions</h2>
        <HideableParagraph
          v-for="(block, idx) in fundingFAQsInformation"
          :key="idx"
          :title="block.title"
          :text="block.text"
        />

        <span>view all <a href="/faq" target="_blank">FAQs</a></span>
      </div>
    </div>
  </div>
</template>

<script>
import { fundingFAQsInformation } from './constants';
import HideableParagraph from '@/components/HideableParagraph';

export default {
  name: 'FAQ',

  components: {
    HideableParagraph
  },

  data() {
    return {
      fundingFAQsInformation
    };
  }
};
</script>

<style lang="scss">
.faq {
  &__title {
    font-size: 18px;
    font-weight: $font-weight-bold;
  }

  a {
    color: inherit;
    text-decoration: underline;
  }
}
</style>
